import { useState, useEffect } from 'react';
import { getListofProjectno, getWIdataexcelbyProjectno } from '../Services/WI-services';
import { removeDuplicates } from '../Components/utility/grid/functions/gbcs-functions';
import { showWarning } from '../Components/utility/ui/notifications/Toaster';

export const useWelderReportCommon = () => {
  const [widata, setwidata] = useState(null);
  const [reload, setReload] = useState(false);
  const [ProjectDetails, setProjectDetails] = useState([]);

  const [wiobj, setwiobj] = useState({
    WI_Project_No: "",
    WI_Joint_No: "",
    WI_Welder_Id: "",
    WI_From_Date: "",
    WI_To_Date: "",
    WI_Slip_Status: "",
    WPS_Rev_no: "",
    WI_FileFormat: "",
  });

  const [error, setError] = useState({
    WI_Project_No: {},
    WI_Joint_No: {},
    WI_Welder_Id: {},
    WI_From_Date: {},
    WI_To_Date: {},
    WI_Slip_Status: {},
  });

  const Slipstatus = [
    { value: "Created", name: "Created" },
    { value: "Cancelled", name: "Cancelled" },
    { value: "Deleted", name: "Deleted" },
  ];

  // Fetch project list
  const fetchListofProject = async () => {
    const result = await getListofProjectno();
    setProjectDetails(result);
  };

  // Fetch welder data for project+joint
  const fetchwidata = async (projectno, jointno) => {
    if (projectno && jointno) {
      const result = await getWIdataexcelbyProjectno(projectno, jointno);
      setwidata(result);
    }
  };

  // Get unique project numbers
  const getUniqueProjectNumbers = () => {
    return [...new Set(ProjectDetails?.map(item => item.SK) || [])];
  };

  // Get joint numbers for selected project
  const getJointNosForSelectedProject = () => {
    if (!wiobj.WI_Project_No || !ProjectDetails?.length) return [];

    const selectedProject = ProjectDetails.find(item => item.SK === wiobj.WI_Project_No);
    if (!selectedProject?.JointNumbers?.values) return [];

    return Array.from(selectedProject.JointNumbers.values).map(jointNo => ({
      label: jointNo,
      value: jointNo,
    }));
  };

  // Get welders for selected project+joint
  const getWelderForSelectedProject = () => {
    if (!wiobj.WI_Project_No || !wiobj.WI_Joint_No || !widata?.length) return [];

    const uniqueWelders = removeDuplicates(x => x.WI_Welder_Id, widata);
    return uniqueWelders.map(welder => ({
      label: welder.WI_Welder_Id,
      value: welder.WI_Welder_Id,
    }));
  };

  // Common validation logic
  const validateDates = async () => {
    let isError = false;

    if (wiobj.WI_From_Date && wiobj.WI_To_Date) {
      if (wiobj.WI_From_Date > wiobj.WI_To_Date) {
        isError = true;
        setError(prev => ({
          ...prev,
          WI_From_Date: { status: true },
          WI_To_Date: { status: true },
        }));
        showWarning("ToDate Should be Greater than or Equal to FromDate");
      }
    }

    return isError;
  };

  // Handle project selection
  const handleProjectChange = (projectValue) => {
    setwiobj(prev => ({
      ...prev,
      WI_Project_No: projectValue,
      WI_Joint_No: "",
      WI_Welder_Id: "",
    }));
  };

  // Handle joint selection
  const handleJointChange = (jointValue) => {
    setwiobj(prev => ({
      ...prev,
      WI_Joint_No: jointValue,
      WI_Welder_Id: "",
    }));
    fetchwidata(wiobj.WI_Project_No, jointValue);
  };

  // Handle welder selection
  const handleWelderChange = (welderValue) => {
    setwiobj(prev => ({
      ...prev,
      WI_Welder_Id: welderValue,
    }));
  };

  // Handle slip status change
  const handleSlipStatusChange = (statusValue) => {
    setwiobj(prev => ({
      ...prev,
      WI_Slip_Status: statusValue,
    }));
  };

  useEffect(() => {
    fetchListofProject();
  }, []);

  useEffect(() => {
    if (reload) {
      setReload(false);
    }
  }, [reload]);

  return {
    // State
    widata,
    wiobj,
    setwiobj,
    error,
    setError,
    ProjectDetails,
    reload,
    setReload,
    Slipstatus,

    // Functions
    fetchListofProject,
    fetchwidata,
    getUniqueProjectNumbers,
    getJointNosForSelectedProject,
    getWelderForSelectedProject,
    validateDates,
    handleProjectChange,
    handleJointChange,
    handleWelderChange,
    handleSlipStatusChange,
  };
};